import { AfterViewInit, Component, ComponentRef, ElementRef, OnInit, signal, ViewChild } from '@angular/core';

import { Utils } from 'src/app/utils/utils';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';
import { CalendarService } from 'src/app/services/calendar/calendar.service';
import { CerraduraService } from 'src/app/services/cerraduras/cerradura.service';

import { CalendarModel } from 'src/app/services/calendar/models/calendar.model';
import { CerraduraModel } from 'src/app/services/cerraduras/models/cerradura.model';
import { AssociateCerraduraModel } from 'src/app/services/cerraduras/models/associateCerradura.model';
import { jqxDateTimeInputComponent } from 'jqwidgets-ng/jqxdatetimeinput';
import { WindowActionButton, WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-associate-lock',
  templateUrl: './associate-lock.component.html',
  styleUrls: ['./associate-lock.component.css']
})
export class AssociateLockComponent implements OnInit, AfterViewInit {
  @ViewChild('gridCalendar') protected gridCalendar: jqxGridComponent;
  @ViewChild('myGridLock') protected myGridLock: jqxGridComponent;
  @ViewChild('myGridLockFree') protected myGridLockFree: jqxGridComponent;
  @ViewChild('formAssociate') public formAssociate: WindowComponent;

  protected calendarsTitle = signal<string>(AppComponent.translate('Calendarios'));
  protected lockTitle = signal<string>(AppComponent.translate('Cerradura'));
  protected lockFreeTitle = signal<string>(AppComponent.translate('Cerraduras_disponible'));

  public static _this: AssociateLockComponent;

  private componentRef = null;
  public theme = environment.tema;
  //  Esto es para que los textos en los controles del grid salgan en español
  public langGrid = JqWidgets.getLocalization('es');
  // variables grid
  protected dataAdapter;
  protected dataAdapterLock;
  protected dataAdapterLockFree;
  private dataSource;
  private dataSourceLock;
  private dataSourceLockFree;
  private checkSelect: CerraduraModel[] = [];
  private calendarios: CalendarModel[] = [];
  private calendario: CalendarModel = new CalendarModel();
  private cerraduras: CerraduraModel[] = [];
  private cerradurasFree: CerraduraModel[] = [];
  private cerradurasAsigneds: CerraduraModel[] = [];
  private empresaId: number;
  private isAssociating: boolean = false;
  private inputDate: jqxDateTimeInputComponent;

  protected loading = signal(false);

  protected actions = [
    {type: "button", action:"salir", value: "", label: this.translate('Salir')}
  ];

  public actionButtonClicked(event: WindowActionButton): void {
    if(event.action === 'salir') {
      this.onClose()
      return;
    }
  }

  private cellClass = (_row: number, _columnfield: unknown, value: unknown): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  // columnas de grids
  public columnCalendar: any = [
    { text: AppComponent.translate('Nombre'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 150, cellclassname: this.cellClass },
    { text: AppComponent.translate('Desde'), width: 70, columntype: 'datetimeinput', filtertype: 'date', datafield: 'desde', cellsformat: 'dd/MM/yyyy', cellclassname: this.cellClass, },
    { text: AppComponent.translate('Hasta'), width: 70, columntype: 'datetimeinput', filtertype: 'date', datafield: 'hasta', cellsformat: 'dd/MM/yyyy', cellclassname: this.cellClass },
    { text: AppComponent.translate('Hora_inicio'), width: 70, columntype: 'datetimeinput', filtertype: 'date', datafield: 'horainicio', cellsformat: 'HH:mm:ss', cellclassname: this.cellClass },
    { text: AppComponent.translate('Hora_fin'), width: 70, columntype: 'datetimeinput', filtertype: 'date', datafield: 'horafin', cellsformat: 'HH:mm:ss', cellclassname: this.cellClass },
    { text: AppComponent.translate('Todos_dias'), width: 40, columntype: 'checkbox', filtertype: 'checkedlist', filteritems: ['Si', 'No'], datafield: 'todosLosDias' },
    { text: AppComponent.translate('Dias_semana'), width: 120, columntype: 'textbox', filtertype: 'checkedlist', datafield: 'diasSemana', cellclassname: this.cellClass },
  ];

  public columnLock: any = [
    { text: AppComponent.translate('Elemento'), columntype: 'textbox', filtertype: 'textbox', datafield: 'elemento', width: 160, cellclassname: this.cellClass },
    { text: AppComponent.translate('Marca'), columntype: 'textbox', filtertype: 'textbox', datafield: 'marca', width: 160, cellclassname: this.cellClass },
    { text: AppComponent.translate('Modelo'), columntype: 'textbox', filtertype: 'textbox', datafield: 'modelo', width: 160, cellclassname: this.cellClass },
    { text: AppComponent.translate('Residuos'), columntype: 'textbox', filtertype: 'textbox', datafield: 'residuos', width: 160, cellclassname: this.cellClass },
    { text: this.translate('Direccion'), columntype: 'textbox', filtertype: 'textbox', datafield: 'calle', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Codigo_postal'), columntype: 'textbox', filtertype: 'textbox', datafield: 'codigoPostal', width: 60, cellclassname: this.cellClass },
    { text: this.translate('Poblacion'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'poblacion', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Municipio'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'municipio', width: 100, cellclassname: this.cellClass },
    { text: this.translate('Provincia'), columntype: 'textbox', filtertype: 'checkedlist', datafield: 'provincia', width: 100, cellclassname: this.cellClass },
  ];

  public constructor(private calendarService: CalendarService,
    private cerraduraService: CerraduraService,
    private ssoService: SsoService,
  ) {
    AssociateLockComponent._this = this;
  }
  public ngAfterViewInit(): void {
    this.getCerraduras();
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public columnmenuopening(menu: any, datafield: string): boolean | void {
    if (menu.length === 1) {
      const divElement: HTMLElement = menu[0];
      const dateTimeInputs = divElement.querySelectorAll('.jqx-datetimeinput');
      if (dateTimeInputs && dateTimeInputs.length > 0 && datafield !== 'desde' && datafield !== 'hasta') {
        dateTimeInputs.forEach((input: HTMLElement) => {
          const elementRef = new ElementRef(input);
          const jqxDateTimeInput = new jqxDateTimeInputComponent(elementRef);
          this.inputDate = jqwidgets.createInstance('#' + jqxDateTimeInput.elementRef.nativeElement.id, 'jqxDateTimeInput', { width: '100%', height: 25, formatString: 'HH:mm:ss' });
          this.inputDate.setOptions({ showTimeButton: true, showCalendarButton: false });
        });
      }

      if (dateTimeInputs && dateTimeInputs.length > 0 && datafield === 'horaInicio' || datafield === 'horaFin') {
        dateTimeInputs.forEach((input: HTMLElement) => {
          const elementRef = new ElementRef(input);
          const jqxDateTimeInput = new jqxDateTimeInputComponent(elementRef);
          this.inputDate = jqwidgets.createInstance('#' + jqxDateTimeInput.elementRef.nativeElement.id, 'jqxDateTimeInput', { width: '100%', height: 25, formatString: 'HH:mm:ss' });
          this.inputDate.setOptions({ showTimeButton: true, showCalendarButton: false });
        });
      }
    }
  }

  /**Inicializa el componente
  */
  public init(componentRef: ComponentRef<AssociateLockComponent>): void {
    this.componentRef = componentRef;
  }

  public ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.empresaId = this.ssoService.getTicket().Empresa.IdGestion;

    this.getCalendar();

  }

  protected closeWindow(): void{
    this.formAssociate.closeWindow();
  }

  public async onRowClick(rowindex: unknown): Promise<void> {
    // busco el calendario en el grid
    const calendar = this.gridCalendar.getrowdatabyid((rowindex as string));
    this.calendario = this.calendarios.find(c => c.id == calendar?.id);

    this.updateGridsOnSelectCalendar();
  }

  private updateGridsOnSelectCalendar(): void {
    this.cerradurasAsigneds = [];
    this.generateArrayCerradurasFree();
    this.cerraduras.forEach(cerradura => {
      const cerr = cerradura.calendarios?.includes(this.calendario.id) || false;

      if(!cerr) {
        return;
      }

      this.cerradurasAsigneds.push(cerradura);
      this.removeFromCerradurasFree(cerradura);
    })

    this.updateGridsData();
  }

  private generateArrayCerradurasFree(): void {
    this.cerradurasFree = [];
    this.cerraduras.forEach(cerradura => {
      if(cerradura.elemento === null) {
        return;
      }

      this.cerradurasFree.push(cerradura);
    })

    this.cerradurasFree.sort((a, b) => (a.id < b.id) ? -1 : 1);
  }

  private removeFromCerradurasFree(cerradura: CerraduraModel): void {
    const index = this.cerradurasFree.findIndex(c => c.id === cerradura.id);

    if(index === -1) {
      return;
    }

    this.cerradurasFree.splice(index, 1);
  }

  private updateGridsData(): void {
    this.dataSourceLock.localdata = this.cerradurasAsigneds;
    this.dataSourceLockFree.localdata = this.cerradurasFree;

    this.myGridLock.updatebounddata('data');
    this.myGridLockFree.updatebounddata('data');
  }

  private async getCalendar(): Promise<void> {
    //this.formAssociate.enableLoader();

    this.calendarios = await this.calendarService.getCalendars();

    this.initGridCalendar();
  }

  private async getCerraduras(): Promise<void> {
    this.loading.set(true);
     await this.cerraduraService.getCerraduras().then(
      (result) => {
        this.cerraduras = result;
        this.cerraduras.map((elem) => {
          elem.calle = (elem.calle || '') + ' ' + (elem.numeroCalle || '');
        });

        this.loading.set(false);
        this.initGridCerraduras();
        this.initGridCerradurasLibres();
      }
    );
  }

  private initGridCalendar(): void {
    if (this.calendarios) {
      this.calendarios.forEach(cal => {
        cal['horaInicio'] = cal.horaInicio1;
        cal['horaFin'] = cal.horaFin1;
      });

      this.dataSource = {
        dataType: 'json',
        dataFields: [
          { name: 'id', type: 'number', map: 'id' },
          { name: 'nombre', type: 'string', map: 'nombre' },
          { name: 'desde', type: 'date', map: 'fechaInicio' },
          { name: 'hasta', type: 'date', map: 'fechaFin' },
          { name: 'todosLosDias', type: 'checkbox', map: 'todosLosDias' },
          { name: 'diasSemana', type: 'string', map: 'diasSemana' },
          { name: 'horainicio', type: 'date', map: 'horaInicio' },
          { name: 'horafin', type: 'date', map: 'horaFin' },
        ],
        localdata: this.calendarios,
      };
      this.dataAdapter = new jqx.dataAdapter(this.dataSource);

      this.columnCalendar.forEach(column => {
        column.rendered = (element): void => { Utils.tooltiprenderer(element) };
      });
    }
  }

  private initGridCerraduras(): void {
    this.dataSourceLock = {
      dataType: 'json',
      dataFields: [
        { name: 'id', type: 'number', map: 'id' },
        { name: 'elemento', type: 'string', map: 'elemento>nombre' },
        { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
        { name: 'imei', type: 'string', map: 'imei' },
        { name: 'nsFabricante', type: 'string', map: 'nsFabricante' },
        { name: 'marca', type: 'string', map: 'elemento>marca' },
        { name: 'modelo', type: 'string', map: 'elemento>modelo' },
        { name: 'residuos', type: 'string', map: 'elemento>equipamiento>ResiduosNombres' },
        { name: 'calle', map: 'calle' },
        { name: 'codigoPostal', map: 'codigoPostal', type: 'string' },
        { name: 'comunidadAutonoma', map: 'comunidadAutonoma' },
        { name: 'municipio', map: 'municipio' },
        { name: 'numeroCalle', map: 'numeroCalle', type: 'number' },
        { name: 'poblacion', map: 'poblacion' },
        { name: 'provincia', map: 'provincia' },
      ],
      localdata: this.cerradurasAsigneds,
    }
    this.dataAdapterLock = new jqx.dataAdapter(this.dataSourceLock);

    this.columnLock.forEach(column => {
      column.rendered = (element): void => { Utils.tooltiprenderer(element) };
    });
  }

  private initGridCerradurasLibres(): void {
    if (this.cerradurasFree) {
      this.cerradurasFree.forEach(cerr => {
        let residuosText = '';
        cerr?.elemento?.equipamiento?.residuos?.forEach(res => {
          residuosText += residuosText === '' ? res.nombre : ', ' + res.nombre
        });
        if(cerr && cerr.elemento && cerr.elemento.equipamiento) {
          cerr.elemento.equipamiento.ResiduosNombres = residuosText;
        }
      });

      this.dataSourceLockFree = {
        dataType: 'json',
        dataFields: [
          { name: 'id', type: 'number', map: 'id' },
          { name: 'elemento', type: 'string', map: 'elemento>nombre' },
          { name: 'nsMovisat', type: 'string', map: 'nsMovisat' },
          { name: 'nsFabricante', type: 'string', map: 'nsFabricante' },
          { name: 'imei', type: 'string', map: 'imei' },
          { name: 'marca', type: 'string', map: 'elemento>marca' },
          { name: 'modelo', type: 'string', map: 'elemento>modelo' },
          { name: 'residuos', type: 'string', map: 'elemento>equipamiento>ResiduosNombres' },
          { name: 'calle', map: 'calle' },
          { name: 'codigoPostal', map: 'codigoPostal', type: 'string' },
          { name: 'municipio', map: 'municipio' },
          { name: 'numeroCalle', map: 'numeroCalle', type: 'number' },
          { name: 'poblacion', map: 'poblacion' },
          { name: 'provincia', map: 'provincia' },
        ],
        localdata: this.cerradurasFree,
      }
      this.dataAdapterLockFree = new jqx.dataAdapter(this.dataSourceLockFree);
    }
  }

  // seleccionar cerraduras en el grid
  protected async onSelectV2(args: {rowindex: [], row: {id:number}}, gridName: string): Promise<void> {
    const { grid, cerraduras } = this.asignedGrid(gridName);

    if(args.rowindex.length === 0) {
      this.checkSelect = [];
      return;
    }

    if(args.row) {
      const cerradurasSeleccionadas = cerraduras.filter(cerradura => cerradura.id == args.row.id)
      this.checkSelect = [...this.checkSelect, ...cerradurasSeleccionadas];
      this.checkSelect = this.onChangeArray(this.checkSelect);
      return
    }

    args.rowindex.forEach(row => {
      const data = grid.getrowdatabyid(row);

      const cerradurasSeleccionadas = cerraduras.filter(cerradura => cerradura.id == data.id)
      this.checkSelect = [...this.checkSelect, ...cerradurasSeleccionadas];
      this.checkSelect = this.onChangeArray(this.checkSelect);
    });
  }

  protected onUnSelect(args: {rowindex: [], row: {id:number}}): void {
    switch (args.rowindex.length) {
      case 0:
        this.checkSelect = [];
        break;
      default:
        this.checkSelect = this.checkSelect.filter(cerradura => cerradura.id !== args.row.id);
        break;
    }
  }

  // devuelve el grid y el array de cerraduras de ese grid
  private asignedGrid(gridname: string): { grid: jqxGridComponent, cerraduras: CerraduraModel[] } {
    let grid: jqxGridComponent;
    let cerraduras: CerraduraModel[] = [];
    switch (gridname) {
      case 'grid1':
        grid = this.myGridLock;
        cerraduras = this.cerradurasAsigneds;
        break;
      case 'grid2':
        grid = this.myGridLockFree;
        cerraduras = this.cerradurasFree;
        break;
    }
    return {
      grid: grid,
      cerraduras: cerraduras
    };
  }

  protected onMasClick(): void {
    if (this.checkSelect.length && this.calendario !== null) {
      this.addGridData(this.checkSelect, this.myGridLockFree);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
      return
    }
  }

  protected onMenosClick(): void {
    if (this.checkSelect.length && this.calendario !== null) {
      this.addGridData(this.checkSelect, this.myGridLock);
    } else {
      MainComponent.getInstance().showWarning('ATENCION', 'Seleccione_registro', 2000);
      return
    }
  }

  // añade o elimina las cerraduras del grid
  private async addGridData(data: any, gridInstance: any): Promise<void> {
    let cerraduraIds: number[] = [];
    if (this.isAssociating) {
      return;
    }
    this.isAssociating = true;
    // si el grid es el de cerradurasFree
    if (gridInstance == this.myGridLockFree) {
      // añado los elementos de data al array de cerraduras
      this.cerradurasAsigneds = [...this.cerradurasAsigneds, ...data];
      cerraduraIds = data.map((cerradura: CerraduraModel) => cerradura.id);
      const associate: AssociateCerraduraModel = new AssociateCerraduraModel(cerraduraIds, [this.calendario.id], this.empresaId);
      await this.calendarService.associateLockList(associate);
      this.cerraduras.forEach(cerradura => {
        if(cerraduraIds.find(id => id === cerradura.id)) {
          cerradura.calendarios.push(this.calendario.id);
        }
      })
      // elimino la cerradura del grid
      this.cerradurasFree = this.cerradurasFree.filter((c) => !cerraduraIds.includes(c.id));

    } else {
      // si el grid es el de cerraduras
      gridInstance = this.myGridLock;
      this.cerradurasFree = [...this.cerradurasFree, ...data];
      cerraduraIds = data.map((cerradura: CerraduraModel) => cerradura.id);
      const associate: AssociateCerraduraModel = new AssociateCerraduraModel(cerraduraIds, [this.calendario.id], this.empresaId);
      await this.calendarService.detachLockList(associate);
      this.cerraduras.forEach(cerradura => {
        if(cerraduraIds.find(id => id === cerradura.id)){
          const idx = cerradura.calendarios.findIndex(cal => cal === this.calendario.id);
          cerradura.calendarios.splice(idx, 1);
        }
      })
      // elimino la cerradura del grid
      this.cerradurasAsigneds = this.cerradurasAsigneds.filter((c) => !cerraduraIds.includes(c.id));
    }
    this.boundataGrids();
    // Si ya se ha asociado se sale de la función
    this.isAssociating = false;
  }

  // quita los elementos duplicados del array y lo devuelve sin undefined
  private onChangeArray(list: CerraduraModel[]): CerraduraModel[] {
    list = list.filter((elem, index, self) =>
      index == self.findIndex((t) => t?.id == elem?.id) && elem !== undefined
    );
    this.checkSelect = list;
    return this.checkSelect;
  }

  protected onClose(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    AssociateLockComponent._this = null;
  }

  protected updatefilterconditions = (type: string, defaultconditions: unknown): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue: any, rowData: any, dataField: string, filterGroup: any, defaultFilterResult: boolean): unknown {
    if (dataField === "todosLosDias") {
      const filters = filterGroup.getfilters();
      for (let i = 0; i < filters.length; i++) {
        const filter = filters[i];
        if (filter.value === "Si") {
          return rowData.todosLosDias;
        }
        else if (filter.value === "No") {
          return !rowData.todosLosDias;
        }
      }
    }else {
      const filterColumns = [
        'nombre',
        'elemento',
        'nsMovisat',
        'nsFabricante',
        'imei',
      ]

      return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
    }
  }

  // Actualizar los grids de cerraduras
  private boundataGrids(): void {
    if(this.cerradurasAsigneds){
      this.cerradurasAsigneds.forEach(cerr => {
        let residuosText = '';
        cerr?.elemento?.equipamiento?.residuos?.forEach(res => {
          residuosText += residuosText === '' ? res.nombre : ', ' + res.nombre
        });
        if(cerr && cerr.elemento && cerr.elemento.equipamiento) {
          cerr.elemento.equipamiento.ResiduosNombres = residuosText;
        }
      });
    }
    this.dataSourceLock.localdata = this.cerradurasAsigneds;
    this.myGridLock.updatebounddata();
    this.myGridLock.clearselection();
    this.dataSourceLockFree.localdata = this.cerradurasFree;
    this.myGridLockFree.updatebounddata();
    this.myGridLockFree.clearselection();
    this.checkSelect = [];
  }

  // Metodos para generar los titulos encima de los grids
  protected onGridCalendarDataUpdated(): void {
    this.__updateGridCalendarTitle(this.gridCalendar?.getrows()?.length);
  }

  private __updateGridCalendarTitle(countJobs: number): void {
    this.calendarsTitle.set(AppComponent.translate('Calendarios') + ' ('+countJobs+')');
  }

  protected onGridLockDataUpdated(): void {
    this.__updateGridLockTitle(this.myGridLock?.getrows()?.length);
  }

  private __updateGridLockTitle(countJobs: number): void {
    this.lockTitle.set(AppComponent.translate('Cerradura') + ' ('+countJobs+')');
  }

  protected onGridLockFreeDataUpdated(): void {
    this.__updateGridLockFreeTitle(this.myGridLockFree?.getrows()?.length);
  }

  private __updateGridLockFreeTitle(countJobs: number): void {
    this.lockFreeTitle.set(AppComponent.translate('Cerraduras_disponible') + ' ('+countJobs+')');
  }
}
